import { useRef, useCallback, useState, useEffect } from 'react'
import { useChatContext } from '../../context/ChatContext'
import Talk from 'talkjs'
import { useChatStore } from '../../store'
import { ConversationSelectedEvent } from 'talkjs/all'
import { ProfessionalDataState } from './InboxDrawer.types'
import { useUnreads } from '@talkjs/react'

export const useInboxDrawer = () => {
  const inboxRef = useRef<Talk.Inbox | null>(null)
  const { conversation, resetConversationSelected } = useChatContext()
  const [professionalData, setProfessionalData] =
    useState<ProfessionalDataState | null>(null)
  const unreads = useUnreads()
  const [loading, setLoading] = useState(false)

  const [openInboxDrawer, updateValueChatStore] = useChatStore(state => [
    state.openInboxDrawer,
    state.updateValue,
  ])

  const handleCloseDrawer = useCallback(() => {
    setProfessionalData(null)
    resetConversationSelected()
    updateValueChatStore('openInboxDrawer', false)
  }, [resetConversationSelected, updateValueChatStore])

  const handleOnConversationSelected = useCallback(
    (conversation: ConversationSelectedEvent) => {
      if (!conversation?.others?.length) return

      setProfessionalData({
        professionalName: conversation?.others[0]?.name,
      })
    },
    [],
  )

  const handleOnLeaveConversation = useCallback(async () => {
    setLoading(true)
    if (inboxRef.current) {
      await inboxRef.current?.select(null).finally(() => setLoading(false))
    } else {
      setLoading(false)
    }
    setProfessionalData(null)
  }, [])

  useEffect(() => {
    updateValueChatStore('hasUnreadMessages', Boolean(unreads?.length))
  }, [unreads?.length, updateValueChatStore])

  return {
    inboxRef,
    conversation,
    openInboxDrawer,
    handleCloseDrawer,
    handleOnConversationSelected,
    handleOnLeaveConversation,
    professionalData,
    loading,
  }
}
